export default __webpack_public_path__ + "media/images/icons/icon_lock_open-9581ebece5a62933d1562da18b868457.svg";